import { useContext } from 'react'
import { LayerContext } from '../components/MapGL/Layers/LayerContext'

export const useMapBounds = () => {
  const { bounds } = useContext(LayerContext)

  return bounds
}
